import React from "react";
import { Euro } from "lucide-react";

interface PriceDisplayProps {
  priceRange?: string | null;
  size?: "sm" | "md";
}

export function PriceDisplay({ priceRange, size = "md" }: PriceDisplayProps) {
  if (!priceRange || priceRange.toLowerCase().includes("unable") || priceRange.toLowerCase().includes("not available")) {
    return null;
  }

  return (
    <div className={`flex items-center gap-1.5 ${size === "sm" ? "text-xs" : "text-sm"} text-muted-foreground`}>
      <Euro size={size === "sm" ? 12 : 14} className="text-grandpal-green shrink-0" />
      <span className="font-medium text-foreground">{priceRange}</span>
    </div>
  );
}
